import { render } from "./SwitchLanguage.vue?vue&type=template&id=4eccb224&ts=true"
import script from "./SwitchLanguage.vue?vue&type=script&lang=ts"
export * from "./SwitchLanguage.vue?vue&type=script&lang=ts"

import "./SwitchLanguage.vue?vue&type=style&index=0&id=4eccb224&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__